// extracted by mini-css-extract-plugin
export var sbShowMain = "section-module--sb-show-main--2ZkQL";
export var section = "section-module--section--OxTvr";
export var none = "section-module--none--1cZwS";
export var grey = "section-module--grey--1pEAp";
export var greyGradient = "section-module--greyGradient--3sWkU";
export var gradient = "section-module--gradient--27fk1";